import {ResourceData} from "../common/resource/resource-service";
import {IEventE4S} from "./event-models";

export class EventData extends ResourceData<IEventE4S> {
    constructor() {
        super("/v5/event");
    }
}
